<template>
    <div class="h-96">
        <navigation class="sticky top-0"/>
        <logo class="mx-auto mt-8"/>
    </div>

    <header class="relative">
        <language-selector class="absolute right-0 bottom-1"/>
        <div class="absolute right-4 bottom-4" v-if="settings.general_social_discord.length !== 0">
            <a :href="'https://discord.gg/' + settings.general_social_discord">
                <i class="fa-brands fa-discord text-5xl text-blue-200"></i>
            </a>
        </div>
    </header>
</template>

<script setup>
import Navigation from "@/Shared/Navigation";
import LanguageSelector from "@/Shared/LanguageSelector";
import {computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Logo from "@/Shared/Logo.vue";

const settings = computed(() => usePage().props.value.config)
</script>
